import { useMutation } from "@tanstack/react-query";
import { authClient } from "../auth-client";

export async function requestOtp(email: string) {
  const { data, error } = await authClient.emailOtp.sendVerificationOtp({
    email,
    type: "sign-in",
  });
  if (error) throw new Error(error.message ?? "Unable to send one time password");
  return data;
}

export async function login({ email, otp }: { email: string; otp: string }) {
  const { data, error } = await authClient.signIn.emailOtp({ email, otp });
  if (error) throw new Error(error.message ?? "Invalid one time password");
  return data;
}

export const useRequestOtp = () => {
  return useMutation({
    mutationKey: ["requestOtp"],
    mutationFn: (email: string) => requestOtp(email),
  });
};

export const useLogin = () => {
  return useMutation({
    mutationKey: ["login"],
    mutationFn: login,
  });
};
